<div style="position: absolute; top:15%; left: 20%; cursor: pointer">
  <a  *ngFor="let items of reportsArray" >
    <a style="padding: 10px;">
      <mat-card  class="reportCard">
        <div class="titleFont" (click)="generateReport(items.reportUrl)"  style="min-width: 365px;   ">{{items.reportName}}</div>
      </mat-card>
    </a>
  </a >
</div>

